import React, { useState, useMemo } from "react";
import { gallery, galleryCategories, heroImages } from "../data/mock";
import { PageHero, Reveal, CTASection } from "../components/common";
import { Dialog, DialogContent } from "../components/ui/dialog";

const Gallery = () => {
  const [active, setActive] = useState(null);
  const [filter, setFilter] = useState("All");

  const chips = ["All", ...galleryCategories.filter((c) => gallery.some((g) => g.cat === c))];
  const items = useMemo(
    () => (filter === "All" ? gallery : gallery.filter((g) => g.cat === filter)),
    [filter]
  );

  return (
    <>
      <PageHero image={gallery[0].src} eyebrow="Tour Gallery" title="Wild Moments on the Water" sub="A look at some of the cool and wild pictures captured on our tours — fish, waves, whales and unforgettable sunsets." />
      <section className="py-14">
        <div className="container-x">
          <div className="flex flex-wrap gap-2.5 mb-10" data-testid="gallery-filter-bar">
            {chips.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setFilter(c)}
                data-testid={`gallery-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-2 rounded-full text-sm font-heading tracking-wide transition-colors duration-200 border ${
                  filter === c
                    ? "bg-[#f5a524] border-[#f5a524] text-[#0a1f33]"
                    : "bg-transparent border-white/20 text-slate-200 hover:bg-white/10"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 [column-fill:_balance]" data-testid="gallery-grid">
            {items.map((g, i) => (
              <Reveal key={`${filter}-${i}`} delay={(i % 4) * 0.05}>
                <button onClick={() => setActive(g.src)} className="mb-4 block w-full overflow-hidden rounded-xl group relative" data-testid={`gallery-item-${i}`}>
                  <img src={g.src} alt={`Hog Tide — ${g.cat}`} className={`w-full object-cover transition duration-500 group-hover:scale-110 ${g.tall ? "h-[420px]" : "h-64"}`} />
                  <span className="absolute bottom-2 left-2 rounded-full bg-black/55 backdrop-blur px-2.5 py-1 text-[11px] font-heading tracking-wide text-white opacity-0 group-hover:opacity-100 transition-opacity">{g.cat}</span>
                </button>
              </Reveal>
            ))}
          </div>

          {items.length === 0 && (
            <p className="text-slate-300 text-center py-16" data-testid="gallery-empty">No photos in this category yet — check back soon.</p>
          )}
        </div>
      </section>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl bg-transparent border-0 p-0 shadow-none">
          {active && <img src={active} alt="Hog Tide" className="w-full max-h-[85vh] object-contain rounded-xl" />}
        </DialogContent>
      </Dialog>
      <CTASection image={heroImages[2].img} />
    </>
  );
};

export default Gallery;
